module.exports = __webpack_public_path__ + "img/c1.278655fa.png";